import * as React from 'react';

import releaseNotesMd from '../assets/RELEASE-NOTES.md';
import * as ReactMarkdown from 'react-markdown';


interface State {
  markdown?: string;
}

class ReleaseNotes extends React.Component<{}, {}> {

  public state: State = {};

  public componentWillMount() {
    fetch(releaseNotesMd)
      .then((response) => response.text())
      .then((text) => {
        this.setState({markdown: text})
      });
  }

  public render(): React.ReactNode {
    const {markdown} = this.state;
    return (
      <div>
        <ReactMarkdown source={markdown}/>
      </div>
    );
  }

}

export default ReleaseNotes;


// WEBPACK FOOTER //
// ./src/app/ReleaseNotes.tsx